module.exports = __webpack_public_path__ + "static/media/gta.7bf71159.woff";